import React from 'react'
import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import { IcomoonIcon } from '@/components/atoms/IcomoonIcon'

export const OpenCloseToggle: React.FC<{
  status: 'open' | 'closed' | 'disabled'
  onClick: () => void
  isLarge?: boolean
  id?: string
}> = ({ status, isLarge, onClick, ...props }) => {
  const fontSize = isLarge ? '24px' : '20px'
  const color =
    status === 'open'
      ? colors.gray70
      : status === 'closed'
        ? colors.blue50
        : colors.gray50
  const iconName = status === 'open' ? 'minus-square-fill' : 'plus-square-fill'
  const cursorStyle = status === 'disabled' ? 'normal' : 'pointer'

  const handleClick = () => {
    if (status === 'disabled') {
      return
    }
    return onClick()
  }

  return (
    <div
      css={css`
        line-height: 0;
      `}
      onClick={handleClick}
      id={props.id}
    >
      <IcomoonIcon
        name={iconName}
        css={css`
          font-weight: ${font.weight.bold};
          color: ${color};
          font-size: ${fontSize};
          cursor: ${cursorStyle};
        `}
      />
    </div>
  )
}
